import { GET_VENDORLIST_REQUESTED, GET_VENDORLIST_SUCCESS, GET_VENDORLIST_FAILED } from "resources/actionTypes";


const initialStateVendorList = {
  vendorList: [],
  loading: false,
  error: null,
};

export function vendorList(state = initialStateVendorList, action) {
  switch (action.type) {
    case GET_VENDORLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDORLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        vendorList: action.vendorList,
      };
    case GET_VENDORLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}